/* tslint:disable */
import {
  CompanyAccount
} from '../index';

declare var Object: any;
export interface CompanyAssetInterface {
  "amount": string;
  "description": string;
  "asset_type": string;
  "debited_account_id": number;
  "credited_account_id": number;
  "currency_id": number;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  "credit_account_id"?: number;
  debitAccount?: CompanyAccount;
  creditAccount?: CompanyAccount;
}

export class CompanyAsset implements CompanyAssetInterface {
  "amount": string;
  "description": string;
  "asset_type": string;
  "debited_account_id": number;
  "credited_account_id": number;
  "currency_id": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  "credit_account_id": number;
  debitAccount: CompanyAccount;
  creditAccount: CompanyAccount;
  constructor(data?: CompanyAssetInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CompanyAsset`.
   */
  public static getModelName() {
    return "CompanyAsset";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CompanyAsset for dynamic purposes.
  **/
  public static factory(data: CompanyAssetInterface): CompanyAsset{
    return new CompanyAsset(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CompanyAsset',
      plural: 'CompanyAssets',
      path: 'CompanyAssets',
      idName: 'id',
      properties: {
        "amount": {
          name: 'amount',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "asset_type": {
          name: 'asset_type',
          type: 'string'
        },
        "debited_account_id": {
          name: 'debited_account_id',
          type: 'number'
        },
        "credited_account_id": {
          name: 'credited_account_id',
          type: 'number'
        },
        "currency_id": {
          name: 'currency_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
        "credit_account_id": {
          name: 'credit_account_id',
          type: 'number'
        },
      },
      relations: {
        debitAccount: {
          name: 'debitAccount',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'debited_account_id',
          keyTo: 'id'
        },
        creditAccount: {
          name: 'creditAccount',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'credit_account_id',
          keyTo: 'id'
        },
      }
    }
  }
}
